/*
 * @FilePath     : /es-package/packages/es-mpx-router/lib/webview.web.js
 * @Author       : LiYang
 * @Date         : 2022-02-24 16:10:58
 * @LastEditTime : 2022-03-21 20:01:14
 * @LastEditors  : Please set LastEditors
 * @Description  : a标签是用于防止浏览器拦截window.open
 */
function openwin(url, callback) {
  let a = document.getElementById('widowopen')
  if (!a) {
    a = document.createElement("a");
    a.setAttribute("id", "widowopen");
    document.body.appendChild(a)
  };
  
  a.setAttribute("href", url);
  a.setAttribute("target", "_blank");
  a.click();
  callback()
}
export default (uri, success, fail) => {
  try {
    openwin(uri, success)
   success()
  } catch (error) {
    fail(error)
  }
}